import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

interface PointProps {
	id: number
	text: string
	Icon: any
}

interface Props {
	serviceProsList: PointProps[]
}

const Point = ({ text, Icon }: PointProps) => (
	<div className={styles.prosItem}>
		<Icon className={styles.svg} />
		<span className={styles.text}>{text}</span>
	</div>
)

export const View = ({ serviceProsList }: Props) => (
	<Section className={styles.wrapper}>
		<div className={styles.content}>
			<h2 className={styles.title}>
				Предоставляем сервис, в котором вы сможете удобно и быстро подавать заявку на целевую
				ипотеку для своих клиентов
			</h2>
			<div className={styles.pros}>
				{serviceProsList.map((item) => (
					<Point key={item.id} {...item} />
				))}
			</div>
			<div className={styles.purpose}>
				<div className={styles.purposeContent}>
					<h4 className={styles.purposeTitle}>Цель сервиса</h4>
					<div className={styles.purposeText}>
						Помочь быстро и точно подавать заявки на ипотеку в банки. Мы упрощаем процессы, которые
						занимают большую часть времени сотрудника.
					</div>
				</div>
				<Image className={styles.rubleSvg} name='ruble.png' />
			</div>
		</div>
	</Section>
)
